export default __webpack_public_path__ + "static/media/4-cassettes-open-2-left.b3d9541c.svg";